import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    current_header_step: "START",
    quoteResponse: null,
    quoteLoading: false,
    quoteError: null,
};

export const amanFormSlice = createSlice({
    name: "aman_form_slice",
    initialState,
    reducers: {
        setAmanFormData: (state, action) => {
            let { form_name, data } = action.payload || {};
            state[form_name] = data;
        },
        clearAmanFormData: (state, action) => {
            const { form_name } = action.payload || {};
            if (form_name) {
                state[form_name] = null;
            }
        },
        setAmanFormHeaderStep: (state, action) => {
            let stepType = action.payload;
            state.current_header_step = stepType;
        },
        setAmanQuoteLoading: (state, action) => {
            state.quoteLoading = action.payload;
            if (action.payload) {
                state.quoteError = null;
            }
        },
        setAmanQuoteResponse: (state, action) => {
            state.quoteResponse = action.payload;
            state.quoteLoading = false;
            state.quoteError = null;
        },
        setAmanQuoteError: (state, action) => {
            state.quoteError = action.payload;
            state.quoteLoading = false;
        },
        clearAllAmanFormData: () => initialState
    }
});

export const selectAmanForm = (store) => store?.amanFormData;
export const selectAmanFormHeaderStep = (store) => store?.amanFormData?.current_header_step;
export const selectAmanQuoteResponse = (store) => store?.amanFormData?.quoteResponse;
export const selectAmanQuoteLoading = (store) => store?.amanFormData?.quoteLoading;
export const selectAmanQuoteError = (store) => store?.amanFormData?.quoteError;

export const { 
    setAmanFormData, 
    clearAmanFormData, 
    setAmanFormHeaderStep, 
    setAmanQuoteLoading,
    setAmanQuoteResponse,
    setAmanQuoteError,
    clearAllAmanFormData 
} = amanFormSlice.actions;

export default amanFormSlice.reducer;
